import { connect } from 'react-redux'
import { catchError } from 'common/redux/modules/error'
import ErrorBoundary from 'common/components/ErrorBoundary'

const mapStateToProps = (state, ownProps) => ({
  ...ownProps
})

const mapDispatchToProps = {
  onError: catchError,
}

 export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorBoundary)
